/* eslint-disable */
import { BasketRebalancing, MutualFundsSIPs } from '../../store/MFStore'
import EmptyState from '../../Components/Common/EmptyState'
import { useRecoilValueLoadable } from 'recoil'
import { Checkbox } from '../../Components/ui/checkbox'
import { useEffect, useState } from 'react'
import { toCurrency } from '../../utils/CurrencyUtil'
import { addMonthForModifySIP, capitalizeWords, cleanIndianPhoneNumber } from '../../utils/Util'
import { useModal } from '../../hooks/use-modal-store'
import { MFTimeBasedBaskets } from '../../store/MFBasketsStore'
import { BASKET_IDS } from '../../constants/sips'
import { Button } from '../../Components/ui/button'
import { useErrorPopup } from '../../hooks/useErrorPopup'
import { post } from '../../http/restservice'
import env from '../../env/env'
import OrderOtpVerification from '../FirstIdeas/OrderOtpVerification'
import rebalancingEmptyIcon from '../../assets/SVGS/action-center-rebalancing-empty.svg'

// const dummyPlans = [
//     {
//         customerBasketInvestmentId: '1',
//         basketIndex: 1,
//         customerBasketName: 'Wealth Builder Plan',
//         oneTimeInvestmentAmount: 50000,
//         oneTimeStatus: 'PENDING',
//         sipStatus: 'PENDING',
//         sipInvestmentAmount: 10000,
//         oneTimeInvestmentBreakdown: [
//             {
//                 amcCode: 'HDFC',
//                 schemeName: 'HDFC Flexi Cap Fund',
//                 investmentAmount: 30000,
//                 weightage: 60,
//             },
//             {
//                 amcCode: 'ICICI',
//                 schemeName: 'ICICI Prudential Bluechip Fund',
//                 investmentAmount: 20000,
//                 weightage: 40,
//             },
//         ],
//         sipInvestmentBreakdown: [
//             {
//                 amcCode: 'HDFC',
//                 schemeName: 'HDFC Flexi Cap Fund',
//                 investmentAmount: 6000,
//                 weightage: 60,
//             },
//             {
//                 amcCode: 'ICICI',
//                 schemeName: 'ICICI Prudential Bluechip Fund',
//                 investmentAmount: 4000,
//                 weightage: 40,
//             },
//         ],
//     },
//     {
//         customerBasketInvestmentId: '2',
//         basketIndex: 2,
//         customerBasketName: 'Retirement Growth Plan',
//         oneTimeInvestmentAmount: 100,
//         oneTimeStatus: 'PENDING',
//         sipStatus: 'PENDING',
//         sipInvestmentAmount: 5000,
//         oneTimeInvestmentBreakdown: [],
//         sipInvestmentBreakdown: [
//             {
//                 amcCode: 'SBI',
//                 schemeName: 'SBI Small Cap Fund',
//                 investmentAmount: 2500,
//                 weightage: 50,
//             },
//             {
//                 amcCode: 'AXIS',
//                 schemeName: 'Axis Midcap Fund',
//                 investmentAmount: 2500,
//                 weightage: 50,
//             },
//         ],
//     },
// ]

const calculatePercentageAmount = (parcentage, totalAmount) => {
  const result = totalAmount * (parcentage / 100)
  return Math.ceil(result)
}

const Rebalancing = ({ clientCode, userDetails }) => {
  const baskets = useRecoilValueLoadable(MFTimeBasedBaskets)
  const investedPlans = useRecoilValueLoadable(MutualFundsSIPs)
  const rebalancing = useRecoilValueLoadable(BasketRebalancing)
  const [groupedBaskets, setGroupedBaskets] = useState({})
  const [allPlans, setAllPlans] = useState([])
  const [selectedPlans, setSelectedPlans] = useState([])
  const [loading, setLoading] = useState(false)
  const [newSipBreakdown, setNewSipBreakdown] = useState([])
  const [openOTPPopup, setOpenOTPPopup] = useState(false)

  const { onOpen } = useModal()
  const { showError } = useErrorPopup()
  const adminPlans = allPlans

  const groupByBasketId = (orders) =>
    orders
      ?.filter((order) => order.sipStatus.toLowerCase() === 'active')
      ?.reduce((acc, { customerBasketInvestmentId, basketStatus, ...order }) => {
        if (!acc[customerBasketInvestmentId]) {
          acc[customerBasketInvestmentId] = []
        }
        acc[customerBasketInvestmentId].push({ basketStatus, customerBasketInvestmentId, ...order })

        return acc
      }, {})

  useEffect(() => {
    // if (rebalancing?.contents?.message?.includes("No basket sip rebalancing found")) {
    //     setAllPlans([])
    //     return
    // }

    const investedData = investedPlans?.contents?.data || []
    const rebalancingData = rebalancing?.contents?.data || []

    const allUserInvestedBaskets = groupByBasketId(investedData)

    const plansMap = new Map()

    rebalancingData.forEach((plan) => {
      if (plan?.customerBasketInvestmentId && plan?.rebalanceStatus === 'REQUIRED') {
        plansMap.set(plan.customerBasketInvestmentId, plan)
      }
    })

    const result = [...plansMap.keys()].map((key) => ({
      ...plansMap.get(key),
      sipInvestmentBreakdown: allUserInvestedBaskets?.[key] || [],
    }))

    setAllPlans(result)
  }, [rebalancing, investedPlans])

  const handleCheckboxChange = (plan) => {
    setSelectedPlans((prev) => {
      const isAlreadySelected = prev.some(
        (p) => p.customerBasketInvestmentId === plan?.customerBasketInvestmentId,
      )
      return isAlreadySelected ? [] : [plan]
    })
  }

  const getNewSipBreakdown = (selectedPlan, totalAmount) => {
    const universalBasketId = selectedPlan.universalBasketId
    const basketFunds =
      baskets?.state === 'hasValue'
        ? baskets?.contents?.data?.filter((plan) => plan.universalBasketId === universalBasketId) ||
          []
        : []
    const sip_basket = BASKET_IDS[universalBasketId] || {}
    const currentBasketVersion = basketFunds[0]?.versionNumber
    const existingBreakdown = selectedPlan?.sipInvestmentBreakdown || []
    const referenceSip = existingBreakdown[0]
    const usedIndexes = new Set()

    const newUpdatedPlan = Object.entries(sip_basket)
      .filter(([, percentage]) => Number(percentage) > 0)
      .flatMap(([schemeCode, percentage]) => {
        const index = existingBreakdown.findIndex(
          (p, i) => !usedIndexes.has(i) && p.schemeCode?.toLowerCase() === schemeCode.toLowerCase(),
        )

        const basketFund = basketFunds.find(
          (f) => f.bseSchemeCode?.toLowerCase() === schemeCode.toLowerCase(),
        )

        if (index !== -1) {
          usedIndexes.add(index)
          const p = existingBreakdown[index]

          return [
            {
              ...p,
              installmentAmt: calculatePercentageAmount(totalAmount, percentage),
              currentBasketVersion,
            },
          ]
        }

        if (!basketFund) return []

        return [
          {
            schemeCode: basketFund.bseSchemeCode,
            schemeName: basketFund.schemeName,
            amcCode: basketFund.amcCode,
            installmentAmt: calculatePercentageAmount(totalAmount, percentage),
            currentBasketVersion,
            sipStartDate: referenceSip?.sipStartDate,
            customerBasketInvestmentId: selectedPlan.customerBasketInvestmentId,
            customerBasketName: referenceSip?.customerBasketName,
          },
        ]
      })

    setNewSipBreakdown(newUpdatedPlan)
    return newUpdatedPlan
  }

  const generateOTP = async () => {
    setLoading(true)

    const response = await post(
      `${env.API_URL}mutualfundservice/api/mutualFund/sendTransactionalOtp`,
      {
        phoneNumber: userDetails?.phoneNumber,
        email: userDetails?.email.includes('fabits') ? '' : userDetails?.email,
      },
    )

    if (response.isError) {
      setLoading(false)
      showError('OTP Error', 'Failed to generate OTP. Please try again later.', () => {})
      return
    }

    if (!response.isError) {
      setOpenOTPPopup(true)
    }
  }

  const handleNewSIPRegistration = async () => {
    setLoading(true)

    const newBasketDistribution = getNewSipBreakdown(
      selectedPlans[0],
      selectedPlans[0].totalSipAmount,
    )

    if (!newBasketDistribution?.length) {
      setLoading(false)
      showError(
        'SIP Rebalancing Failed',
        'Unable to build the new basket allocation. Please try again later or contact support.',
        () => {},
      )
      return
    }

    const mandateId =
      newBasketDistribution.find((item) => item?.mandateId)?.mandateId ||
      selectedPlans[0]?.sipInvestmentBreakdown?.find((item) => item?.mandateId)?.mandateId

    if (!mandateId) {
      setLoading(false)
      showError(
        'Mandate Issue',
        'There is an issue with your mandate. Please contact our support team for assistance before rebalancing.',
        () => {},
      )
      return
    }

    const newBasketDistributionPayload = newBasketDistribution.map((item) => ({
      schemeCode: item.schemeCode,
      installmentAmount: item.installmentAmt,
    }))

    const payload = {
      clientCode: clientCode?.toUpperCase(),
      mandateId,
      currentBasketSips: selectedPlans[0]?.sipInvestmentBreakdown?.map((item) => ({
        schemeCode: item.schemeCode,
        folioNumber: item.folioNo,
        sipRegId: item.sipRegId,
      })),

      newBasketDistribution: newBasketDistributionPayload,
      customerBasketInvestmentId: selectedPlans[0]?.customerBasketInvestmentId,
      phoneNumber: cleanIndianPhoneNumber(userDetails?.phoneNumber),
      startDate: addMonthForModifySIP(5, newBasketDistribution[0]?.sipStartDate?.split('/')[0]),
      isRebalanceUpdate: true,
      currentBasketVersion: newBasketDistribution[0]?.currentBasketVersion,
    }

    const updateSIP = await post(`mutualfundservice/api/basket/sipUpdate`, payload)

    if (updateSIP?.isError) {
      setLoading(false)

      showError(
        'SIP Rebalancing Failed',
        'We were unable to rebalance your portfolio. Please try again later or contact support if the issue persists.',
        () => {},
      )
      return
    }

    if (updateSIP?.status === 'SUCCESS') {
      setLoading(false)

      onOpen('openSIPPopup', {
        title: 'Rebalancing Successful',
        message: 'Your portfolio has been rebalanced successfully.',
        severity: 'rebalancing',
      })
    }
  }

  return (
    <div className='mx-4 mt-3 md:mx-auto md:max-w-[760px] lg:max-w-[1128px]'>
      {/* <div>
                <h1 className='flex justify-between items-center mt-4'>
                    <span className='font-DMSans font-semibold text-lg md:text-xl text-black-500'>
                        Rebalancing
                    </span>
                </h1>
                <p className='font-DMSans md:text-lg text-sm font-normal text-black-400'>
                    Rebalance your portfolio to optimize your returns.
                </p>
            </div> */}

      {adminPlans?.length > 0 && (
        <div className='fabits-card my-4 flex justify-between p-4'>
          <p className='text-sm font-medium leading-relaxed text-black-600'>
            You can select and proceed with one plan at a time, then move on to the next plan.
          </p>
          {/* <span
                    className={`font-DMSans font-medium text-sm ${isAllSelected ? 'text-black-300' : 'text-primary-600'
                        } cursor-pointer`}
                    onClick={() => setIsAllSelected(!isAllSelected)}
                >
                    {isAllSelected ? 'Deselect All' : 'Select All'}
                </span> */}
        </div>
      )}

      <div
        className={`gap-2 pb-56 md:pb-0 ${
          adminPlans?.length > 0 ? 'md:flex' : 'flex w-full justify-center'
        }`}
      >
        {adminPlans?.length > 0 ? (
          <div className='flex flex-[2] flex-col gap-4 md:grid md:grid-cols-2 md:gap-4 lg:grid-cols-2'>
            {adminPlans?.map((plan, index) => {
              return (
                <div
                  key={plan.customerBasketInvestmentId + index}
                  className='fabits-card overflow-hidden p-4 transition-all duration-300 ease-in-out hover:border-primary-200 md:p-5'
                >
                  <div className='flex justify-between'>
                    <div className='flex items-start gap-3'>
                      <Checkbox
                        className='mt-1 h-5 w-5'
                        checked={selectedPlans?.some(
                          (p) => p.customerBasketInvestmentId === plan?.customerBasketInvestmentId,
                        )}
                        onCheckedChange={() => handleCheckboxChange(plan)}
                      />
                      <div className='font-IBM text-base font-bold leading-snug text-black-950 md:text-lg'>
                        {plan?.sipInvestmentBreakdown[0]?.customerBasketName ||
                          plan?.customerBasketName ||
                          'Rebalancing Plan'}
                      </div>
                    </div>
                  </div>

                  <div className='mt-4 grid grid-cols-2 gap-3'>
                    <div className='rounded-lg border border-black-100 bg-black-50 p-3'>
                      <h1 className='fabits-eyebrow flex items-center gap-2'>Old SIP</h1>
                      <p className='mt-2 font-IBM text-lg font-bold text-black-950 md:text-xl'>
                        ₹
                        {toCurrency(
                          plan?.sipInvestmentBreakdown?.reduce(
                            (acc, p) => acc + Number(p.installmentAmt),
                            0,
                          ),
                        )}
                      </p>
                      {plan.sipInvestmentBreakdown && (
                        <p
                          className='mt-3 cursor-pointer font-DMSans text-xs font-semibold text-primary-600 hover:text-primary-700'
                          onClick={() => {
                            onOpen('sipBreakdown', {
                              constituents: plan?.sipInvestmentBreakdown,
                            })
                          }}
                        >
                          View Funds
                        </p>
                      )}
                    </div>

                    <div className='rounded-lg border border-black-100 bg-black-50 p-3'>
                      <h1 className='fabits-eyebrow flex flex-wrap items-center gap-2'>
                        New SIP{' '}
                        <span
                          className={`rounded-full border px-2 py-0.5 text-[10px] font-semibold normal-case tracking-normal ${
                            capitalizeWords(plan?.sipStatus) === 'Active'
                              ? 'border-secondary-300 bg-secondary-300 text-black-950'
                              : 'border-warning-500 bg-warning-50 text-warning-700'
                          }`}
                        >
                          {capitalizeWords(plan?.sipStatus) === 'Active' ? 'Active' : 'Pending'}
                        </span>
                      </h1>

                      <p className='mt-2 font-IBM text-lg font-bold text-black-950 md:text-xl'>
                        ₹{plan.totalSipAmount ? toCurrency(plan.totalSipAmount) : 0}
                      </p>

                      {plan.totalSipAmount > 0 && (
                        <p
                          className='mt-3 cursor-pointer font-DMSans text-xs font-semibold text-primary-600 hover:text-primary-700'
                          onClick={() => {
                            onOpen('sipBreakdown', {
                              constituents: getNewSipBreakdown(plan, plan.totalSipAmount),
                              totalAmount: plan?.totalSipAmount,
                            })
                          }}
                        >
                          View Funds
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        ) : (
          <EmptyState
            icon={
              <span
                aria-hidden='true'
                className='fabits-action-center-empty-graphic'
                style={{ '--fabits-empty-graphic-url': `url(${rebalancingEmptyIcon})` }}
              />
            }
            title='No Action required'
            description={
              <span className='mx-auto block max-w-[520px] leading-relaxed'>
                Your portfolio is still <span className='fabits-marker'>aligned</span> with your
                goals and risk profile. We only suggest rebalancing when allocations drift
                meaningfully, so there is <span className='fabits-marker'>no action needed</span>{' '}
                right now.
              </span>
            }
          />
        )}
      </div>

      {adminPlans?.length > 0 && (
        <div className='fabits-bottom-sheet fixed bottom-0 left-0 right-0 z-10 mx-auto mt-2 p-4 lg:max-w-[1128px]'>
          <div className='mx-auto space-y-2'>
            {/* <div className='mt-4'>
                            <Popover>
                                <PopoverTrigger asChild>
                                    <Button
                                        variant={'outline'}
                                        className='pl-3 font-normal border-none bg-primary-50 rounded-lg w-full flex justify-between mx-auto'
                                    >
                                        <span className='text-primary-500 flex items-center gap-x-2'>
                                            <CalendarIcon className='ml-auto h-4 w-4 opacity-50' />
                                            <p>
                                                SIP starts on -{' '}
                                                <b>
                                                    {addNumberSuffix(sipDate.split('/')[0])}{' '}
                                                    {monthShortNames[parseInt(sipDate.split('/')[1], 10) - 1]}{' '}
                                                    {sipDate.split('/')[2]}
                                                </b>
                                            </p>
                                        </span>

                                        <Pen className='h-4 w-4 text-primary-500' />
                                    </Button>
                                </PopoverTrigger>
                                <PopoverContent className='p-0 w-auto rounded-full' align='center' side='top'>
                                    <div className='flex gap-x-2 p-2'>
                                        {sipDates.map((day, index) => (
                                            <Button
                                                key={(day + index).toString()}
                                                className={`h-8 w-8 rounded-full inline-block ${selectedDay !== +day
                                                    ? 'bg-white border border-primary-50 text-black-400 hover:bg-primary-50'
                                                    : 'text-white'
                                                    }`}
                                                size='simple'
                                                onClick={() => setSelectedDay(+day)}
                                            >
                                                {day}
                                            </Button>
                                        ))}
                                    </div>
                                </PopoverContent>
                            </Popover>
                        </div> */}

            <Button
              disabled={selectedPlans?.length === 0}
              className='w-full bg-primary-600 disabled:bg-primary-300'
              onClick={generateOTP}
              loading={loading}
            >
              Continue
            </Button>

            {/* <p className='text-xs mt-2 text-center font-semibold'>
                        Keep your internet banking password ready for quick setup.
                    </p> */}
          </div>
        </div>
      )}

      {adminPlans?.length > 0 && openOTPPopup && (
        <OrderOtpVerification
          loading={loading}
          phoneNumber={userDetails?.phoneNumber}
          openOTPPopup={openOTPPopup}
          setOpenOTPPopup={setOpenOTPPopup}
          email={userDetails?.email}
          handleSipOrOT={handleNewSIPRegistration}
        />
      )}
    </div>
  )
}

export default Rebalancing
